import { QuoteCarousel } from './der-content-quote-carousel.component';
export * from './der-content-quote-carousel.component';
export default QuoteCarousel;

QuoteCarousel.define('der-content-quote-carousel');

declare global {
    interface HTMLElementTagNameMap {
        'der-content-quote-carousel': QuoteCarousel;
    }
}
